import clientBridge from '@common/client/src/bridge'
import cookieKit from '../lib/cookie-kit'

// 获取设备信息
const getClientInfo = () => {
  return new Promise((resolve, reject) => {
    clientBridge.call('cardniu://api/getUserInfo', 'onGetUserInfo', (dataInfo) => {
      if (dataInfo && dataInfo.version) {
        console.log('Collect cardniu Data:', dataInfo)
        resolve(dataInfo)
      } else {
        reject('获取卡牛客户端信息失败')
      }
    })
  })
}

export default class CardniuClient {
  static clientInfo = null
  async getClientInfo() {
    if (!this.clientInfo) {
      try {
        const result = await getClientInfo()
        this.clientInfo = result || {}
      } catch (error) {
        console.warn('Collect cardniu Error:', error)
      }
    }
    return {
      appName: (window.navigator.userAgent.indexOf('ruiloansms') !== -1) ? 'ruiloan' : 'cardniu',
      appVersion: this.clientInfo.version || '',
      channel: this.clientInfo.channel || '',
      udid: this.clientInfo.UDID || (cookieKit.get('app_udid') || ''),
    }
  }
}
